import { Product } from './product'
import { Service } from './service'
import { Staff } from './staff'
export class History {
    constructor(history) {
        this.id = history.id;
        this.customer_id = history.customer_id;
        this.created_at = history.created_at;
        this.update_at = history.update_at;
        this.owner_id = history.owner_id;
        this.checkin_id = history.checkin_id;
        this.status = history.status;
        this.note = history.note;
        this.total_price = history.total_price;
        this.discount = history.discount;
        this.user_id = history.user_id;
        this.point_bonus = history.point_bonus;
        this.check_in = history.check_in ? new Checkin(history.check_in) : null;
        this.survey = history.survey;
        this.staff = history.staff;
        this.customer = history.customer;
        this.customer_point = history.customer_point;
        this.redeem = history.redeem;
        this.promotion = history.promotion;
        this.list_redeem = history.list_redeem;
        this.list_promotion = history.list_promotion;
        this.invoice = history.invoice;
    }
}

class Checkin {
    constructor(checkin) {
        this.id = checkin.id;
        this.customer_id = checkin.customer_id;
        this.create_at = checkin.create_at;
        this.status = checkin.status;
        this.update_at = checkin.update_at;
        this.services = checkin.services ? this.getServiceList(checkin.services) : [];
        this.staffs = checkin.staffs ? this.getStaffList(checkin.staffs) : [];
        this.products = checkin.products ? this.getProductList(checkin.products) : [];
        this.attachment = checkin.attachment;
        this.customer_checkin_services = checkin.customer_checkin_services;
    }
    getServiceList(services) {
        let ser_arr = [];
        for(let i = 0; i < services.length; i++) {
          ser_arr.push(new Service(services[i]));
        }
        return ser_arr;
    }
    getStaffList(staffs) {
        let staff_arr = [];
        for(let i = 0; i < staffs.length; i++) {
          staff_arr.push(new Staff(staffs[i]));
        }
        return staff_arr;
    }

    getProductList(products) {
        let pro_arr = [];
        for(let i = 0; i < products.length; i++) {
          pro_arr.push(new Product(products[i]));
        }
        return pro_arr;
    }
}
